"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequiredOptionItem = void 0;
const RequiredOption_1 = require("../entity/RequiredOption");
const createRequiredOptionItem = ({ key = 'create', point = 80, rewardAmount = 15000, rewardCurrency = 'JPY', } = {}) => new RequiredOption_1.RequiredOptionItem({ key, point, rewardAmount, rewardCurrency });
exports.createRequiredOptionItem = createRequiredOptionItem;
